import React, { createContext, useContext, useEffect, useState } from 'react';
import { PCLAYOUTID, PCPROID, PCPSTEP, PCROWCOL } from '../utils/utils.ts';

const RootContext = createContext(null);
export const RootProvider = ({children}) => {
  const [ curLayoutId, setCurLayoutId ] = useState(-1);
  const [ curProId, setCurProId ] = useState('');
  const [ otherProId, setOtherProId ] = useState('');
  const [ showDatabaseWin, setShowDatabaseWin ] = useState(false);

  const [rowCol, setRowCol] = useState({
    row: 0,
    col: 0
  });
  const [step, setStep] = useState(1);

  useEffect(() => {
    if(curProId) {
      sessionStorage.setItem(PCPROID, curProId);
    }
  }, [curProId]);

  useEffect(() => {
    if(curLayoutId !== -1) {
      sessionStorage.setItem(PCLAYOUTID, curLayoutId);
    } else {
      // sessionStorage.removeItem('curLayoutId');
    } 
  }, [curLayoutId]); 

  useEffect(() => {
    if(step > 1) {
      sessionStorage.setItem(PCPSTEP, step);
    }
  }, [step]);

  useEffect(() => {
    const proId = sessionStorage.getItem(PCPROID);
    const layoutId = sessionStorage.getItem(PCLAYOUTID);
    const step = sessionStorage.getItem(PCPSTEP);
    const rowCol = JSON.parse(sessionStorage.getItem(PCROWCOL) || '{"row": 0, "col": 0}');

    if(proId) {
      setCurProId(proId);
    }
    if(layoutId) {
      setCurLayoutId(parseInt(layoutId, 10));
    }
    if(step) {
      setStep(parseInt(step, 10));
    }
    setRowCol(rowCol);
  }, []);

  return <RootContext.Provider value={{
    rowCol,
    step,
    curProId,
    curLayoutId,
    otherProId,
    showDatabaseWin,

    setRowCol,
    setStep,
    setCurProId,
    setCurLayoutId,
    setOtherProId,
    setShowDatabaseWin
  }}>
    {children}
  </RootContext.Provider>;
};

export const useRoot = () => {
  return useContext(RootContext) || {
    rowCol: {row: 0, col: 0},
    step: 0,
    curProId: '',
    curLayoutId: -1,
    otherProId: '',
    showDatabaseWin: false,

    setRowCol: () => {},
    setStep: () => {},
    setCurProId: () => {},
    setCurLayoutId: () => {},
    setOtherProId: () => {},
    setShowDatabaseWin: () => {}
  };
};